import { createCodedError } from '~/common/errors/CodedError';
import { JsonApiErrorResponse } from '~/redux/api/ApiTypes';
import { testIsAxiosError } from '~/redux/api/utils';
import { everest } from '~/services/serviceInstances';

interface GetAmendIntakeFormParams {
  contractRecordUniqueId: string;
}

export const getAmendIntakeForm = async ({
  contractRecordUniqueId,
}: GetAmendIntakeFormParams) => {
  try {
    return await everest.get(
      `/integrate-workflow/amend/${contractRecordUniqueId}/intake-form`,
    );
  } catch (error) {
    if (testIsAxiosError<JsonApiErrorResponse>(error) && error.response) {
      const errorResponse = error.response.data.errors?.[0];
      if (errorResponse) {
        throw createCodedError({
          message: errorResponse.detail ?? errorResponse.title,
          statusCode: errorResponse.status,
          title: errorResponse.title,
        });
      }
    }

    throw error;
  }
};
